import { IconComponentsProps } from './types';

const ChevronDownIcon = ({ fill = 'white', ...props }: IconComponentsProps) => (
  <svg
    focusable="false"
    preserveAspectRatio="xMidYMid meet"
    fill={fill}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z"></path>
  </svg>
);

export default ChevronDownIcon;
